import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Typography, Switch, FormControlLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import { useSnackbar } from 'notistack';

import * as talentAlertApi from './../../../api/talentAlertApi';

import { UPDATE_TALENT_ALERT_GIF_GENERATION } from './../../../actions/talentAlertActions';

import { BlockHeader } from './../../../components/LayoutComponents/BlockHeader';

const useStyles = makeStyles(() => ({
  switchContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '15px'
  }
}));

const TalentAlertGifGeneration = () => {

  const [t] = useTranslation(['newTranslations', 'tooltips']);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  const talentAlert = useSelector((state) => state.talentAlert);
  const { id: campaignId } = talentAlert;

  const [gifGenerationEnabled, setGifGenerationEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    talentAlertApi.getGifGenerationSetting({ campaignId })
      .then((response) => {
        const autoGenerate = response.data;
        setGifGenerationEnabled(autoGenerate);
        
        // Update Redux state with the fetched value
        dispatch({
          type: UPDATE_TALENT_ALERT_GIF_GENERATION,
          autoGenerate
        });
      })
      .catch((error) => {
        console.log(error);
        enqueueSnackbar('Failed to get GIF generation setting', { variant: 'error' });
      })
      .finally(() => {
        setIsLoading(false);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGifGenerationChange = (event) => {
    const autoGenerate = event.target.checked;
    setGifGenerationEnabled(autoGenerate);

    dispatch({
      type: UPDATE_TALENT_ALERT_GIF_GENERATION,
      autoGenerate
    });

    talentAlertApi.updateGifGenerationSetting({ campaignId, autoGenerate })
      .then(() => {
        enqueueSnackbar('GIF Generation Setting Updated', { variant: 'success' });
      })
      .catch((error) => {
        console.log(error);
        enqueueSnackbar('GIF Generation Setting Update Failed', { variant: 'error' });
      });
  };

  if (isLoading) {
    return (
      <>
        <BlockHeader
          headerTooltip={t("tooltips:gifGenerationSetting")}
          header={t("newTranslations:enableGifGeneration")} />
        
        <div className={classes.switchContainer}>
          <Typography variant="body1">
            {t("newTranslations:enableGifGeneration")}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Loading...
          </Typography>
        </div>
      </>
    );
  }

  return (
    <>
      <BlockHeader
        headerTooltip={t("tooltips:gifGenerationSetting")}
        header={t("newTranslations:enableGifGeneration")} />
      
      <div className={classes.switchContainer}>
        <Typography variant="body1">
          {t("newTranslations:enableGifGeneration")}
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={gifGenerationEnabled}
              onChange={handleGifGenerationChange}
              color="primary"
            />
          }
          label=""
        />
      </div>
    </>
  );

};

export default TalentAlertGifGeneration; 